import React from 'react';

const ratio = 0.288389513108614;
const RmaLogo = ({
  height,
  marginLeft = 8,
  marginBottom = 2,
  marginTop = 0,
}: {
  height: number;
  marginLeft?: number;
  marginBottom?: number;
  marginTop?: number;
}): JSX.Element => (
  <div
    style={{
      height,
      marginLeft,
      marginBottom,
      marginTop,
    }}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={height / ratio}
      height={height}
      viewBox="0 0 267 77"
    >
      <desc>ratemyagent.com.au</desc>
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g transform="translate(-217 -451)">
          <g transform="translate(217 451)">
            <path
              fill="#1A222C"
              d="M259.45 4.45c0-2.03 1.62-3.69 3.64-3.69 2.03 0 3.67 1.66 3.67 3.69 0 2.03-1.64 3.7-3.67 3.7-2.02 0-3.64-1.67-3.64-3.7zm.78 0c0 1.68 1.26 2.97 2.86 2.97 1.6 0 2.86-1.29 2.86-2.97 0-1.68-1.26-2.96-2.86-2.96-1.6 0-2.86 1.28-2.86 2.96zm2.4-.18h.52c.45 0 .7-.22.7-.59 0-.39-.25-.61-.7-.61h-.52v1.2zm0 .66v1.5h-.76V2.41h1.39c.78 0 1.36.55 1.36 1.26 0 .56-.36 1.02-.88 1.19l.9 1.57h-.87l-.84-1.5h-.3z"
            />
            <path
              fill="#1A222C"
              d="M9.797 67h239.194c4.425 0 8.009-3.579 8.009-7.994V8.994C257 4.572 253.414 1 248.991 1H8.01C3.584 1 0 4.579 0 8.994v67.803L9.797 67z"
            />
            <path
              fill="#FFF"
              d="M30.32 25.12c-.4-.12-1-.2-1.6-.2-1.6 0-4.12.64-5.16 2.88v-2.68h-5.88V45h6.08v-8.68c0-3.96 2.2-5.4 4.64-5.4.6 0 1.24.04 1.92.2v-6zm1.357 14.4c0-3.52 2.6-5.52 5.88-6l4.68-.72c1.08-.16 1.44-.68 1.44-1.36 0-1.16-1-2.16-2.92-2.16-2.12 0-3.28 1.44-3.4 2.92l-5.28-1.08c.24-2.84 2.88-6.6 8.72-6.6 6.44 0 8.8 3.6 8.8 7.68v9.72c0 1.56.2 2.88.24 3.08h-5.48c-.04-.16-.2-.88-.2-2.24-1.04 1.68-2.96 2.8-5.6 2.8-4.36 0-6.88-2.88-6.88-6.04zm8.36 1.64c1.8 0 3.64-.88 3.64-3.96v-.88l-3.76.6c-1.28.2-2.24.8-2.24 2.2 0 1.04.68 2.04 2.36 2.04zm20.476-21.84h-5.44v2.56c0 1.84-1 3.24-3.08 3.24h-1v5.32h3.52v8.52c0 3.96 2.52 6.4 6.64 6.4 1.92 0 2.92-.44 3.16-.56v-5.04c-.36.08-.96.2-1.6.2-1.32 0-2.2-.44-2.2-2.08v-7.44h3.88v-5.32h-3.88v-5.8zM71.79 32.68h7.96c-.08-1.52-1.12-3.36-4-3.36-2.56 0-3.84 1.88-3.96 3.36zm8.4 5.16l5.08 1.44c-.96 3.44-4.12 6.32-9.16 6.32-5.48 0-10.36-3.92-10.36-10.6 0-6.4 4.76-10.48 9.92-10.48 6.16 0 9.96 3.8 9.96 10.2 0 .84-.08 1.76-.12 1.88H71.67c.12 2.24 2.16 3.84 4.52 3.84 2.2 0 3.44-1.04 4-2.6zM92.507 45V33.4c0-2.88 1.8-4.88 4.48-4.88 2.88 0 4.08 1.92 4.08 4.4V45h3.76V33.36c0-2.76 1.8-4.84 4.44-4.84 2.84 0 4.08 1.88 4.08 4.4V45h3.72V32.52c0-5.04-3.28-7.32-6.64-7.32-2.44 0-4.92.88-6.44 3.64-1.04-2.48-3.36-3.64-5.76-3.64-2.24 0-4.64 1-5.84 3.12v-2.56h-3.6V45h3.72zm34.076 8.04l12.52-27.28h-4.04l-5.76 13.28-6-13.28h-4.32l8.28 17.12-4.8 10.16h4.12zM139.7 39.52c0-3.52 2.6-5.52 5.88-6l4.68-.72c1.08-.16 1.44-.68 1.44-1.36 0-1.16-1-2.16-2.92-2.16-2.12 0-3.28 1.44-3.4 2.92l-5.28-1.08c.24-2.84 2.88-6.6 8.72-6.6 6.44 0 8.8 3.6 8.8 7.68v9.72c0 1.56.2 2.88.24 3.08h-5.48c-.04-.16-.2-.88-.2-2.24-1.04 1.68-2.96 2.8-5.6 2.8-4.36 0-6.88-2.88-6.88-6.04zm8.36 1.64c1.8 0 3.64-.88 3.64-3.96v-.88l-3.76.6c-1.28.2-2.24.8-2.24 2.2 0 1.04.68 2.04 2.36 2.04zm11.877 4.96l5.36-1.52c.4 1.92 2 3.32 4.28 3.32 3.04 0 4.92-1.48 4.92-5.08v-.92c-.72 1.08-2.44 2.24-5.32 2.24-5.28 0-9.24-4.16-9.24-9.68 0-5.24 3.8-9.72 9.24-9.72 3.24 0 4.96 1.44 5.52 2.48v-2.12h5.8v17.4c0 5.72-3.2 10.68-10.64 10.68-5.72 0-9.36-3.52-9.92-7.08zm10.36-7.24c2.48 0 4.24-1.68 4.24-4.4 0-2.72-1.96-4.4-4.24-4.4-2.28 0-4.28 1.68-4.28 4.4 0 2.72 1.84 4.4 4.28 4.4zm18.636-6.2h7.96c-.08-1.52-1.12-3.36-4-3.36-2.56 0-3.84 1.88-3.96 3.36zm8.4 5.16l5.08 1.44c-.96 3.44-4.12 6.32-9.16 6.32-5.48 0-10.36-3.92-10.36-10.6 0-6.4 4.76-10.48 9.92-10.48 6.16 0 9.96 3.8 9.96 10.2 0 .84-.08 1.76-.12 1.88h-13.84c.12 2.24 2.16 3.84 4.52 3.84 2.2 0 3.44-1.04 4-2.6zm14.157-4.24c0-2 1.28-3.48 3.28-3.48 2.2 0 3.24 1.48 3.24 3.44V45h6.08V32.52c0-4.36-2.24-7.92-7.24-7.92-2.04 0-4.48.92-5.56 2.8v-2.28h-5.88V45h6.08V33.6zm23.717-14.28h-5.44v2.56c0 1.84-1 3.24-3.08 3.24h-1v5.32h3.52v8.52c0 3.96 2.52 6.4 6.64 6.4 1.92 0 2.92-.44 3.16-.56v-5.04c-.36.08-.96.2-1.6.2-1.32 0-2.2-.44-2.2-2.08v-7.44h3.88v-5.32h-3.88v-5.8z"
            />
          </g>
        </g>
      </g>
    </svg>
  </div>
);

export default RmaLogo;
